import { render, staticRenderFns } from "./ShowAlianzaStores.vue?vue&type=template&id=919bac88"
import script from "./ShowAlianzaStores.vue?vue&type=script&lang=js"
export * from "./ShowAlianzaStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('919bac88')) {
      api.createRecord('919bac88', component.options)
    } else {
      api.reload('919bac88', component.options)
    }
    module.hot.accept("./ShowAlianzaStores.vue?vue&type=template&id=919bac88", function () {
      api.rerender('919bac88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/alianzas/components/ShowAlianzaStores.vue"
export default component.exports